export default __webpack_public_path__ + "static/media/muffito_logo.a40e2900.png";